import { motion } from 'framer-motion';
import { DOMAIN_SHORT_NAMES, getScoreLevel } from '../../lib/api';

export default function NeuralFrictionMap({ domainScores }) {
  if (!domainScores || domainScores.length === 0) {
    return (
      <div className="flex items-center justify-center h-32 text-muted-foreground">
        No data available
      </div>
    );
  }

  // Create a grid of cells based on scores
  const generateCells = (score) => {
    const cellCount = 10;
    const cells = [];
    const filledCount = Math.round((score / 100) * cellCount);
    
    for (let i = 0; i < cellCount; i++) {
      cells.push(i < filledCount);
    }
    return cells;
  };

  return (
    <div className="space-y-4">
      {domainScores.map((domain, index) => {
        const cells = generateCells(domain.dysfunction_score);
        const level = getScoreLevel(domain.dysfunction_score);
        
        return (
          <motion.div
            key={domain.domain}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.05 }}
            className="flex items-center gap-4"
          >
            <div className="w-28 shrink-0">
              <p className="text-sm font-medium">
                {DOMAIN_SHORT_NAMES[domain.domain]}
              </p>
            </div>
            
            <div className="flex-1 flex gap-1">
              {cells.map((filled, i) => (
                <div
                  key={i}
                  className="flex-1 h-7 rounded transition-all"
                  style={{
                    backgroundColor: filled ? level.color : 'hsl(var(--secondary))',
                    opacity: filled ? 0.45 + (i * 0.055) : 0.2
                  }}
                />
              ))}
            </div>
            
            <div className="w-16 shrink-0 text-right">
              <span 
                className="text-sm font-mono font-bold"
                style={{ color: level.color }}
              >
                {domain.dysfunction_score.toFixed(0)}
              </span>
            </div>
          </motion.div>
        );
      })}
      
      {/* Scale */}
      <div className="flex items-center justify-between pt-4 border-t border-border mt-4">
        <span className="text-xs text-muted-foreground">Balanced</span>
        <div className="flex gap-1">
          <div className="w-4 h-4 rounded bg-emerald-500/30" />
          <div className="w-4 h-4 rounded bg-amber-500/30" />
          <div className="w-4 h-4 rounded bg-orange-500/30" />
          <div className="w-4 h-4 rounded bg-red-500/30" />
        </div>
        <span className="text-xs text-muted-foreground">High Friction</span>
      </div>
    </div>
  );
}
